export default __webpack_public_path__ + "static/media/red-cross.d7fad0e2.svg";